import { Flex } from '@chakra-ui/react';
import { KAvatarItem } from './KAvatarItem';
import { KText } from '@/ui-library/components/text';
import { KPopover } from '@/ui-library/components/organisms/KPopover';

export const KAvatarList = ({
  avatarList = [] as any,
  showName = true,
  alignItems = 'center',
  gap = '2px',
  flexDir = 'row' as any,
  size,
  color = 'secondary-900',
  maxDisplay = 5,
  avatarProps = {},
  containerProps = {},
  plusMoreContainerProps = { ml: '-20px', zIndex: 1 },
  plusMoreAvatarcontainerProps = {
    p: '10px',
    borderBottom: '1px solid #E9EBF4',
    alignItems: 'center',
    gap: '12px',
  },
  plusMoreAvatarProps = {
    className: 'avatar-xs',
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    border: '1px solid #fff',
  },
}) => {
  // Split avatars into visible and hidden based on maxDisplay
  const visibleAvatars = avatarList.slice(0, maxDisplay);
  const hiddenAvatars = avatarList.slice(maxDisplay);
  const remainingCount = hiddenAvatars.length;

  const renderPlusMoreTriggerContent = () => {
    return (
      <Flex
        bg="secondary-50"
        minWidth="24px"
        height="24px"
        alignItems="center"
        justifyContent="center"
        borderRadius={'6px'}
        border="1px solid #fff"
        cursor={'pointer'}
        {...plusMoreContainerProps}
      >
        <KText
          color={'secondary-700'}
          width="content-fit"
          fontWeight="550"
          fontSize={'12px'}
          px="3px"
        >
          +{remainingCount}
        </KText>
      </Flex>
    );
  };

  const renderKAvatarItem = (visibleAvatars) => {
    return (
      <Flex gap={gap} alignItems={alignItems} flexDir={flexDir}>
        {visibleAvatars?.map((avatarItr, index) => {
          return (
            <KAvatarItem
              key={index}
              name={avatarItr?.name}
              src={avatarItr?.avatar || null}
              showName={showName}
              avatarProps={avatarProps}
              size={size}
              color={color}
            />
          );
        })}
      </Flex>
    );
  };

  return (
    <Flex
      gap={gap}
      alignItems={alignItems}
      flexDir={flexDir}
      {...containerProps}
    >
      {(remainingCount > 0 || showName) && renderKAvatarItem(visibleAvatars)}
      {!showName && (
        <KPopover
          // popoverActions={{ isOpen: true }}
          popoverProps={{ trigger: 'hover' }}
          triggerElement={
            remainingCount > 0
              ? renderPlusMoreTriggerContent()
              : renderKAvatarItem(visibleAvatars)
          }
          children={avatarList.map((avatarItr, index) => (
            <KAvatarItem
              key={index}
              user={avatarItr}
              name={avatarItr?.name}
              src={avatarItr?.avatar || null}
              showName={true}
              avatarProps={plusMoreAvatarProps}
              containerProps={plusMoreAvatarcontainerProps}
              size={size}
              color={color}
              lineHeight="1.1rem"
            />
          ))}
          showCloseButton={false}
          popoverContentProps={{
            p: '0',
            maxHeight: '340px',
            overflow: 'scroll',
          }}
          popoverBodyProps={{ p: '0px' }}
        ></KPopover>
      )}
    </Flex>
  );
};
